var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("nav"),_vm._v(" "),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }